module.exports = __webpack_public_path__ + "img/activity31.4ca10a04.png";